import axios from "axios";
import { toastMessage } from "components/ToastMessage";

export const handleThunkError = (error: unknown, message?: string) => {
  if (axios.isCancel(error)) return;
  if (message) {
    toastMessage({ message, type: "error", position: "top-right" });
  }
};
